// extracted by mini-css-extract-plugin
export default {"input":"TabProductInfo_input__ukfCP TabProductSetup_input__QGOqz"};